<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="percentage" class="demo-form-inline" label-width="150px"  size="mini">
                    <el-form-item label="名称">
                        <el-input v-model="percentage.condition.percentageName" placeholder="名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="queryPercentage">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="percentages"
                    border
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    max-height="360"
                    ref="tb"
                    size="mini">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column prop="percentageName" label="名称" width="200"></el-table-column>
                    <el-table-column prop="percentageStatus" label="状态" width="200" :formatter="formatStatus"></el-table-column>
                    <el-table-column prop="totalRatio" label="总分成比例" width="150">
                        <template slot-scope="scope"> {{scope.row.totalRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="salerRatio" label="销售比例" width="200">
                        <template slot-scope="scope"> {{scope.row.salerRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="receiverRatio" label="接单比例" width="200">
                        <template slot-scope="scope"> {{scope.row.receiverRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="operatorRatio" label="操作比例" width="200">
                        <template slot-scope="scope"> {{scope.row.operatorRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="auxiliaryRatio" label="辅助比例" width="200">
                        <template slot-scope="scope"> {{scope.row.auxiliaryRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="directorRatio" label="主管比例" width="200">
                        <template slot-scope="scope"> {{scope.row.directorRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                    <el-table-column prop="createBy" label="创建人" width="200"></el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        <el-row class="row-button">
            <el-button size="small" type="info" @click="handlecancel">取消</el-button>
            <el-button size="small" type="primary" @click="handleChecked">确定</el-button>
        </el-row>

    </div>
    
</template>

<script>

    export default {
        name:'PercentageSearch',
        props: ["percentageId"],
        components: {
        },
        data() {
            return {
                percentage:{
                    condition:{
                        percentageStatus:"NORMAL",
                    },
                    pageNum: 1,
                    pageSize:10
                },
                drawer: false,
                direction: 'rtl',
                percentages: [],
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                percentageProp:{},
                title:"新增提成比例",
                dataStatuses:[],
                selectedPercentage:{}
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryPercentage();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryPercentage();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryPercentage();
                })
                .catch(() => {});
            },
            queryPercentage() {
                this.percentage.pageNum = this.currentPage;
                this.percentage.pageSize = this.pageSize;
                this.$axios.post("/percentage/find",this.percentage).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.percentages = res.data.result.list;
                            this.total = res.data.result.total;
                            this.selectedPercentage = this.percentages[0];
                            
                            this.$nextTick(()=>{
                                this.percentages.forEach(row=>{
                                    if(this.percentageId) {
                                        if(this.percentageId == row.percentageId) {
                                            this.$refs.tb.toggleRowSelection(row);
                                        }
                                    }
                                })
                            })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
            },
            queryStatus() {
                let condition = {value:"DATA_STATUS"};
                this.$axios.post("/dictionary/findByDictType",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.dataStatuses = res.data.result;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            formatStatus(row) {
                return row.percentageStatus == "NORMAL" ? "正常": row.percentageStatus == "FROZEN" ? "冻结" : "已删除";
            },
            handleCloseDrawer() {
                this.drawer = false;
            },
            //处理多选框选中事件
            handleSelectionChange(selection) {
                if (selection.length > 1) {
                    this.$refs.tb.clearSelection();
                    this.$refs.tb.toggleRowSelection(selection.pop());
                }else if (selection.length === 1) {
                    this.selectedPercentage = selection.pop()
                } else {
                    this.selectedPercentage = {}
                }
            },
            //处理确定按钮
            handleChecked() {
                this.$bus.$emit(this.GlobeConstant.percentagesearch_to_orderinfoupdate, this.selectedPercentage);
            },
            handlecancel() {
                this.$bus.$emit(this.GlobeConstant.percentagesearch_to_orderinfoupdate_close);
            }
        },
        mounted() {
            this.queryPercentage();
            this.queryStatus();
        },
        beforeDestroy() {
        }
        
    }


</script>

<style scoped>

   /* .el-row {
       margin-top: 10px;
       text-align: left;
       padding-left: 10px;
   } */
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .line {
        text-align: center;
   }
   .row-button {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
   }

   .row-button >.el-button {
        margin-top: 10px;
   }

</style>
